/** Auto-generated by import-constants plugin. Do not edit manually */

export const optionalImportEntrypoints: string[] = [
  "langchain/chat_models/universal",
  "langchain/cache/file_system",
  "langchain/storage/file_system",
  "langchain/hub/index",
  "langchain/hub/node",
];
